import { getItemOrDefaultToValue, getPersonName } from 'utils/details';
import { getRiskLevelId, getRiskLevelValue } from '../../helper/zone';

const getRegionAndZones = data => {
  const region = {
    type: 'POLYGON',
    riskLevel: getRiskLevelId(data.currentRisk?.rating),
    boundary: data.boundary.points.map(point => ({
      lat: point.latitude,
      lng: point.longitude,
    })),
  };

  const zones =
    data.zones !== null
      ? data.zones.map(zone => ({
          type: 'POLYGON',
          riskLevel: getRiskLevelId(zone.currentRisk?.rating),
          boundary: zone.boundary.points.map(point => ({
            lat: point.latitude,
            lng: point.longitude,
          })),
        }))
      : [];

  return [region, ...zones];
};

const getSecurityCompaniesDisplay = securityCompanies => {
  return securityCompanies.map(securityCompany => ({
    display: `${getItemOrDefaultToValue(
      securityCompany,
      'name',
      '-',
    )} - ${getItemOrDefaultToValue(
      securityCompany,
      'regionName',
      '-',
    )} - ${getItemOrDefaultToValue(
      securityCompany.operationPhone,
      'prefix',
      '-',
    )} ${getItemOrDefaultToValue(
      securityCompany.operationPhone,
      'number',
      '-',
    )}`,
  }));
};

export const transformRegionDetails = region => {
  return {
    id: region.id,
    name: region.name,
    currency: region.currency,
    regionBoundary: region.boundary.points.map(bound => ({
      lat: bound.latitude,
      lng: bound.longitude,
    })),
    defaultTimeZone: getItemOrDefaultToValue(region, 'defaultTimeZone'),
    regionRisk: getItemOrDefaultToValue(region.currentRisk, 'rating'),
    regionRiskContext: getItemOrDefaultToValue(region.currentRisk, 'context'),
    zones: getItemOrDefaultToValue(region, 'zones', []).map(zone => {
      return {
        id: getItemOrDefaultToValue(zone, 'id'),
        name: getItemOrDefaultToValue(zone, 'name'),
        boundary: zone.boundary.points.map(bound => ({
          lat: bound.latitude,
          lng: bound.longitude,
        })),
        riskLevel: getRiskLevelId(zone.currentRisk.rating),
        riskContext: getItemOrDefaultToValue(zone.currentRisk, 'context'),
      };
    }),
    centreOfGravity: {
      lat: region.boundary.centreOfGravity.latitude,
      lng: region.boundary.centreOfGravity.longitude,
    },
  };
};

export const transformDetailViewRegionDetails = (region, securityCompanies) => {
  return {
    generalInfo: {
      name: {
        type: 'text',
        value: getItemOrDefaultToValue(region, 'name'),
      },
      currency: {
        type: 'text',
        value: getItemOrDefaultToValue(region, 'currency'),
      },
      manager: {
        type: 'text',
        value: region.manager != null ? getPersonName(region.manager) : '-',
      },
    },
    detailedInfo: {
      defaultSecurityCompanyName: {
        type: 'text',
        value: getItemOrDefaultToValue(region, 'defaultSecurityCompanyName'),
      },
      securityCompanies: {
        type: 'array',
        value: getSecurityCompaniesDisplay(securityCompanies),
      },
      currentRisk: {
        type: 'text',
        value: getRiskLevelValue(region.currentRisk, 'rating'),
      },
      regionsAndZones: {
        type: 'map-compound',
        value: getRegionAndZones(region),
      },
    },
    others: {
      archived: { value: getItemOrDefaultToValue(region, 'archived') },
    },
  };
};
